import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createGaren(id = 'garen-1', team = 'red', x = 1800, y = 500) {
  const garen = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 575,
    maxMp: 0, // Garen is manaless
    ad: 70,
    ap: 0,
    armor: 40,
    mr: 32,
    ms: 340,
    attackRange: 175,
    attackSpeed: 0.625,
    name: 'Garen',
    radius: 22
  });

  garen.qEmpowered = false;
  garen.wActive = false;
  garen.damageReduction = 0;
  garen.tenacity = 0;
  garen.isSpinning = false;
  garen.spinTimer = 0;

  garen.applyEmpoweredQ = function(target) {
    if (!this.qEmpowered || !target || target.isDead) return;
    const extraDamage = 30 + this.ad * 0.5;
    target.takeDamage(this.ad + extraDamage, 'physical');
    if (target.statusManager && target.statusManager.addEffect) {
      target.statusManager.addEffect(EFFECT_TYPES.SILENCE, 1.5);
    }
    this.qEmpowered = false;
  };

  return garen;
}

export function castGarenQ(garen) {
  if (garen.statusManager && garen.statusManager.effects) {
    garen.statusManager.effects = garen.statusManager.effects.filter(e => e.type !== EFFECT_TYPES.SLOW);
  }
  garen.ms += 100; // Speed boost
  garen.qEmpowered = true;
}

export function castGarenW(garen) {
  garen.wActive = true;
  garen.damageReduction = 0.3; // 30% damage reduction
  garen.tenacity = 0.3; // 30% tenacity
}

export function castGarenE(garen, nearbyEntities) {
  garen.isSpinning = true;
  garen.spinTimer = 3.0; // Spins for 3s
  nearbyEntities.forEach(e => {
    if (e.team !== garen.team && !e.isDead && isInAbilityCircle(e, garen.x, garen.y, 325, garen)) {
      e.takeDamage(35 + garen.ad * 0.4, 'physical');
    }
  });
}

export function castGarenR(garen, target) {
  if (!target || target.isDead) return;
  if (!isWithinAbilityRange(garen, target, 400, garen)) return;
  const missingHp = target.maxHp - target.hp;
  const trueDamage = 150 + missingHp * 0.28;
  target.takeDamage(trueDamage, 'true');
}

